import Vue from "vue";
import VueRouter from "vue-router";
import ChooseCard from "./components/ChooseCard";
import CodeUret from "./components/CodeUret";
import Ekran from "./components/Ekran";
import Ekran_final from "./components/Ekran_final";
import Ekran_game from "./components/Ekran_game";
import Final from "./components/Final";
import Game from "./components/Game";
import Login from "./components/Login_bayrakli";
import Master from "./components/Master";
import MasterList from "./components/MasterList";
import MasterPlay from "./components/MasterPlay";
import Sunucu from "./components/Sunucu";
import Teknoted_addGame from "./components/Teknoted_addGame";
import Teknoted_addUsers from "./components/Teknoted_addUsers";
//import store from './store/index'

Vue.use(VueRouter);

const routes = [
  //website
  { name: "ChooseCard", component: ChooseCard, path: "/chooseCard" },
  { name: "Login", component: Login, path: "/login" },
  { name: "CodeUret", component: CodeUret, path: "/codeuret" },

  {
    name: "Teknoted_addGame",
    component: Teknoted_addGame,
    path: "/teknoted_addGame",
  },
  {
    name: "Teknoted_addUsers",
    component: Teknoted_addUsers,
    path: "/teknoted_addUsers",
  },

  { name: "Demo", component: Login, path: "/", meta: { company: "demo" } },
  { name: "Demo", component: Login, path: "/demo", meta: { company: "demo" } },
  { name: "Demo", component: Login, path: "/mapfre", meta: { company: "demo" } },
  {
    name: "Demo_ChooseCard",
    component: ChooseCard,
    path: "/demo/choose",
    meta: { company: "demo" },
  },
  {
    name: "Demo_Game",
    component: Game,
    path: "/demo/game",
    meta: { company: "demo" },
  },
  {
    name: "Demo_Master",
    component: Master,
    path: "/demo/master",
    meta: { company: "demo" },
  },
  {
    name: "Demo_MasterPlay",
    component: MasterPlay,
    path: "/demo/master/play",
    meta: { company: "demo" },
  },
  {
    name: "Demo_Final",
    component: Final,
    path: "/demo/final",
    meta: { company: "demo" },
  },
  {
    name: "Demo_Sunucu",
    component: Sunucu,
    path: "/demo/sunucu",
    meta: { company: "demo" },
  },
  {
    name: "Demo_MasterList",
    component: MasterList,
    path: "/demo/master/list",
    meta: { company: "demo" },
  },

  {
    name: "demo_Ekran",
    component: Ekran,
    path: "/demo/ekran",
    meta: { company: "demo" },
  },

  {
    name: "demo_Ekran_game",
    component: Ekran_game,
    path: "/demo/ekran_game",
    meta: { company: "demo" },
  },
  {
    name: "demo_Ekran_final",
    component: Ekran_final,
    path: "/demo/ekran_final",
    meta: { company: "demo" },
  },

  //////
];

const router = new VueRouter({
  mode: "history",
  base: "",
  routes,
});

//const loginRoute = '/login';

/*
router.beforeEach(async (to, from, next) => {

    const user_group = store.getters.getUserGroup;


    if( to.meta.permission != "all" && user_group != to.meta.permission){
        next({ path: loginRoute });
    }else{
        next();
    }
    

  
    
    
});




{
    name: "mapfres",
    component: Login,
    path: "/",
    meta: { company: "mapfre" },
  },

  {
    name: "mapfre",
    component: Login,
    path: "/mapfre",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_ChooseCard",
    component: ChooseCard,
    path: "/mapfre/choose",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Game",
    component: Game,
    path: "/mapfre/game",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Master",
    component: Master,
    path: "/mapfre/master",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_MasterPlay",
    component: MasterPlay,
    path: "/mapfre/master/play",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Final",
    component: Final,
    path: "/mapfre/final",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Sunucu",
    component: Sunucu,
    path: "/mapfre/sunucu",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_MasterList",
    component: MasterList,
    path: "/mapfre/master/list",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_AllList",
    component: AllList,
    path: "/mapfre/allList",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Ekran",
    component: Ekran,
    path: "/mapfre/ekran",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Ekran_game",
    component: Ekran_game,
    path: "/mapfre/ekran_game",
    meta: { company: "mapfre" },
  },
  {
    name: "mapfre_Ekran_final",
    component: Ekran_final,
    path: "/mapfre/ekran_final",
    meta: { company: "mapfre" },
  },
  */

export default router;
